import { render, staticRenderFns } from "./SolicitacaoListagem.vue?vue&type=template&id=2a7f953b&scoped=true"
import script from "./SolicitacaoListagem.vue?vue&type=script&lang=js"
export * from "./SolicitacaoListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7f953b",
  null
  
)

export default component.exports